// PB-2323: client account restrictions (soft / hard / custom blocks) as the portal sees them.
//
// `/user/get` carries `restrictions: { blocked: [...capabilities], blockType }`, fetched live on
// every call. Only an enforced block appears; the reason is never sent. This is presentation only:
// the server refuses a blocked action whatever the portal shows.

export const CAPABILITY = Object.freeze({
  DEPOSIT: 'DEPOSIT',
  BUY: 'BUY',
  ROLLOVER: 'ROLLOVER',
  SELL: 'SELL',
  WITHDRAW: 'WITHDRAW',
  WHITELIST_CHANGE: 'WHITELIST_CHANGE',
});

// Same wording as the server's CLIENT_RESTRICTED refusal, so the banner and an error toast agree.
export const RESTRICTED_MESSAGE =
  'Some actions on your account are currently unavailable. Please contact your relationship manager.';

export const RESTRICTED_ERROR_CODE = 'CLIENT_RESTRICTED';

// Fired by api.js when the server refuses a request as restricted.
export const RESTRICTION_EVENT = 'sindi:client-restricted';

export const blockedCapabilities = (restrictions) =>
  Array.isArray(restrictions?.blocked) ? restrictions.blocked : [];

export const isRestricted = (restrictions) =>
  blockedCapabilities(restrictions).length > 0;

export const isCapabilityBlocked = (restrictions, capability) =>
  blockedCapabilities(restrictions).includes(capability);

// A refusal from the gate, in either envelope the portal receives.
export const isRestrictedResponse = (resp) =>
  resp != null &&
  (resp?.data?.errorCode === RESTRICTED_ERROR_CODE ||
    resp?.msg === RESTRICTED_MESSAGE ||
    resp?.message === RESTRICTED_MESSAGE);
